import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';

const { spacing, fonts, colors } = dggTheme;

export const buttonLink = css`
  width: fit-content;
  border-radius: ${pxToRem(12)};
  margin: ${pxToRem(spacing.xs)} 0;
  padding: ${pxToRem(spacing.sm)} ${pxToRem(spacing.xl)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  background-color: var(--backgroundColor);
  text-decoration: none;
`;

export const buttonTextLight = css`
  color: ${colors.neutralWhite};
`;

export const buttonTextDark = css`
  color: ${colors.parisM};
`;
